import { Box } from '@mui/material';
import React from 'react';
import Banner from '../../atoms/Banner/Banner';
import ContentBox from '../../molecules/ContentBox';
import releaseList from '../../../data/realese.json';
import Table from '../../organisms/Table/Table';

const bannerData = {
  imgSrc: '/images/image/footprint@2x.png',
  imgSrcM: '/images/image/foot print m@2x.png',
  title: 'Press Release',
  text1: 'This is a press release from the BoB, which is attracting attention for its distinctive white hacker education led by the government.',
};

const headerList = [
  {
    name: 'No.',
    value: 'no',
    width: 15,
  },
  {
    name: 'Title',
    value: 'title',
    width: 70,
  },

  {
    name: 'Date',
    value: 'date',
    width: 15,
  },
  // {
  //   name: 'Link',
  //   value: 'link',
  //   width: 25,
  // },
];

const handleClickRow = (r) => {
  if (!r.link) return;
  window.open(r.link);
};

export default function PressReleasePage() {
  return (
    <Box>
      <Banner bannerData={bannerData} />
      <ContentBox>
        <Table rows={releaseList} headers={headerList} onClickRow={handleClickRow} />
      </ContentBox>
    </Box>
  );
}
